import React from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs, defaultColDef } from './definitions-config';

function CompaniesTable({ rowData, handleMergeDialog, handleVerify }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='flex items-center justify-center mt-1'>
        <button
          className='rounded px-4 bg-orange-c1 mr-2 text-white'
          onClick={() => handleMergeDialog(params.data)}
        >
          Merge
        </button>
        <button
          className='rounded px-4 bg-green-c1 text-white'
          onClick={() => handleVerify(params.data)}
        >
          Verify
        </button>
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };

  return (
    <div className='ag-theme-alpine' style={{ height: '85vh', width: '100%' }}>
      <AgGridReact
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        pagination={true}
        paginationPageSize={10}
        paginationAutoPageSize={true}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        rowHeight={50}
        frameworkComponents={frameworkComponents}
      />
    </div>
  );
}

export default CompaniesTable;
